import React, { ReactElement } from "react";
import DeviceTypeEnum from "../../../enums/DeviceTypeEnum";
import Image from "../../../components/image/Image";
import styles from "./topbarlogo.module.scss";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { UserState } from "redux-oidc";
import IAppState from "infrastructure/store/IAppState";
import UserManager from "infrastructure/oidc/UserManager";

interface IProps { 
  type: DeviceTypeEnum;
}

const TopBarLogo : React.FC<IProps> = (props) => {
  const user = useSelector<IAppState, UserState>((s) => s.oidc).user;
  const isLoggedUser = () => !!user;

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    UserManager.signinRedirect();
  };

  let logoClass = (type: string) => {
    switch (type) {
      case DeviceTypeEnum.MOBILE:
        return `d-md-none ${styles.topbarLogo}`;
      case DeviceTypeEnum.DESKTOP:
        return `d-none d-md-flex navbar-brand ${styles.topbarLogo}`;
      default:
        return "d-none";
    }
  }

  if (!isLoggedUser()) {
    return (
      <a href="#" onClick={handleLogoClick} className={logoClass(props.type)}>
        <Image imgPath="logo.png" className={styles.topbarLogoImg} alt="Logo" />
      </a>
    );
  }

  return (
    <Link to="/" className={logoClass(props.type)}>
      <Image imgPath="logo.png" className={styles.topbarLogoImg} alt="Logo" />
    </Link>
  );
};

export default TopBarLogo;